/* @jsxImportSource react */

import type { FragmentType } from '@packages/gql/generated/shopping';
import { unmask } from '@packages/gql/src/betterMasking';
import { ProductCardV2AvailabilityOverlayDynamic } from '@packages/modules/src/ProductCardV2/ProductCardV2.AvailabilityOverlay.dynamic';
import type { ProductListAvailabilityOverlayFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductListAvailabilityOverlayFragmentFragmentDoc';

/* GraphQL */ `
  fragment ProductListAvailabilityOverlayFragment on ProductAvailability {
    ... on AvailabilityDescription {
      description
    }
    ... on AvailableVariations {
      variations {
        availability {
          description
        }
        href
        name
      }
    }
  }
`;

export type ProductListAvailabilityOverlayProps = {
  href: string;
  groupName?: string;
  maskedAvailability: FragmentType<typeof ProductListAvailabilityOverlayFragmentFragmentDoc>;
};

export const ProductListAvailabilityOverlay = ({
  href,
  groupName,
  maskedAvailability,
}: ProductListAvailabilityOverlayProps) => {
  const availability =
    unmask<typeof ProductListAvailabilityOverlayFragmentFragmentDoc>(maskedAvailability);

  return (
    <ProductCardV2AvailabilityOverlayDynamic
      availability={availability}
      alternateLink={href}
      variationGroupName={groupName}
    />
  );
};
